const {BASE_URL} = require('./client');

const GET_NOTIFICATIONS = BASE_URL + '/api/notification/get';
const DELETE_NOTIFICATIONS = BASE_URL + '/api/notification/delete/';
module.exports = {
    GET_NOTIFICATIONS,
    DELETE_NOTIFICATIONS
}